import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/mobile.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { installGlobalErrorHandlers } from "@/services/errorLogger";

installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
